var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import moment from 'moment';
import { isCMG } from '@ally/transfer-account-utils';
import { getGuid } from '@ally/data-selectors-user';
import { toTitleCase } from '@ally/aos-utils';
import { CATCH_ALL_ERROR_MESSAGE, SAVE_TRANSFER_ERROR_CODES, SAVE_TRANSFER_EXCEPTION_CODES, } from '../constants';
import transferToRequest from './transferToRequest';
import { getTransferType } from '..';
var isObject = function (val) {
    if (val === null)
        return false;
    if (moment.isMoment(val))
        return false;
    return typeof val === 'object';
};
var deepClone = function (obj) {
    if (Array.isArray(obj)) {
        // TODO: clean up this TS
        return obj.map(function (value) { return (isObject(value) ? deepClone(value) : value); });
    }
    return Object.entries(obj).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = isObject(value) ? deepClone(value) : value, _b)));
    }, {});
};
export var updateAccount = function (account, _a) {
    var newCurrentBalance = _a.currentBalancePvtEncrypt, newAvailableBalance = _a.availableBalancePvtEncrypt, newHelocBalance = _a.helocAvailableBalancePvtEncrypt;
    var clone = deepClone(account);
    clone.currentBalance = newCurrentBalance !== null && newCurrentBalance !== void 0 ? newCurrentBalance : clone.currentBalance;
    clone.availableBalance = newAvailableBalance !== null && newAvailableBalance !== void 0 ? newAvailableBalance : clone.availableBalance;
    if (isCMG(clone) && newHelocBalance !== undefined) {
        clone.domainDetails.helocAvailableBalancePvtEncrypt = newHelocBalance;
    }
    return clone;
};
export var getTransferStatus = function (transfer, transferStatus) {
    var isInvest = getTransferType(transfer.fromAccount, transfer.toAccount) === 'INVEST';
    if (isInvest && transferStatus === 'submitted') {
        return 'Processing';
    }
    return toTitleCase(transferStatus);
};
export var consolidateTransferData = function (transfer, payload) {
    var transferId = payload.transferId, fromAccount = payload.fromAccount, toAccount = payload.toAccount, errors = payload.errors, transferStatus = payload.transferStatus;
    var clone = deepClone(transfer);
    clone.confirmationNumber = transferId;
    if (transferStatus) {
        clone.status = getTransferStatus(transfer, transferStatus);
    }
    if (errors) {
        clone.warning = SAVE_TRANSFER_EXCEPTION_CODES[errors[0].errorCode];
    }
    clone.fromAccount = updateAccount(clone.fromAccount, fromAccount);
    clone.toAccount = updateAccount(clone.toAccount, toAccount);
    return clone;
};
function saveTransfer(transfer, hostServices) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var hostData, fetch, session, guid, data, payload, error_1, message;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    hostData = hostServices.hostData, fetch = hostServices.utils.fetch, session = hostServices.session;
                    guid = ((_a = session.data) === null || _a === void 0 ? void 0 : _a.guid) || getGuid(hostData);
                    data = JSON.stringify(transferToRequest(transfer));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch.CAPI({
                            url: "/v2/customers/".concat(guid, "/transfers?isPlatformWeb=true"),
                            method: 'POST',
                            data: data,
                        })];
                case 2:
                    payload = (_b.sent()).payload;
                    if (payload === null)
                        return [2 /*return*/, transfer];
                    return [2 /*return*/, consolidateTransferData(transfer, payload)];
                case 3:
                    error_1 = _b.sent();
                    message = SAVE_TRANSFER_ERROR_CODES[error_1.errorCode] ||
                        error_1.errorDescription ||
                        CATCH_ALL_ERROR_MESSAGE;
                    throw new Error(message);
                case 4: return [2 /*return*/];
            }
        });
    });
}
export default saveTransfer;
//# sourceMappingURL=saveTransfer.js.map